<template>
  <div>
    <h2 class="title is-2">
      Subscription invoices
    </h2>
    <table
      v-if="subscriptionLoaded && subscriptionInvoices.length > 0"
      class="table is-fullwidth"
    >
      <tr>
        <th>Date</th>
        <th>Description</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Download</th>
      </tr>
      <tr
        v-for="invoice in subscriptionInvoices"
        :key="invoice.pk"
      >
        <td>{{ invoice.created_at.substring(0, 10) }}</td>
        <td>{{ invoice.items[0].description }}</td>
        <td>{{ invoice.amount_due|formattedDbAmount(null, 2, invoice.currency) }}</td>
        <td>{{ invoice.status }}</td>
        <td>
          <div class="buttons are-small">
            <a
              class="button"
              @click="handleSubscriptionPdfDownload(invoice.pk)"
            >PDF</a>
          </div>
        </td>
      </tr>
    </table>
    <b-notification
      v-if="subscriptionLoaded && subscriptionInvoices.length === 0"
      :closable="false"
    >
      You have no subscription invoices.
    </b-notification>
    <div
      v-if="!subscriptionLoaded"
      class="columns"
    >
      <div class="column is-12 has-text-centered">
        <br>
        <span
          class="loader xl"
          style="display: inline-block; width: 3em; height: 3em;"
        />
      </div>
    </div>

    <h2 class="title is-2">
      Licensing invoices
    </h2>
    <table
      v-if="licensingLoaded && licensingInvoices.length > 0"
      class="table is-fullwidth"
    >
      <tr>
        <th>Date</th>
        <th>Description</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Download</th>
      </tr>
      <tr
        v-for="invoice in licensingInvoices"
        :key="invoice.pk"
      >
        <td>{{ invoice.created_at.substring(0, 10) }}</td>
        <td>{{ invoice.items[0].description }}</td>
        <td>{{ invoice.amount_due|formattedDbAmount(null, 2, invoice.currency.code) }}</td>
        <td>{{ invoice.is_paid ? "paid" : "due" }}</td>
        <td>
          <div class="buttons are-small">
            <a
              class="button"
              @click="handleLicensingPdfDownload(invoice.pk)"
            >PDF</a>
          </div>
        </td>
      </tr>
    </table>
    <b-notification
      v-if="licensingLoaded && licensingInvoices.length === 0"
      :closable="false"
    >
      You have no licensing invoices.
    </b-notification>
    <div
      v-if="!licensingLoaded"
      class="columns"
    >
      <div class="column is-12 has-text-centered">
        <br>
        <span
          class="loader xl"
          style="display: inline-block; width: 3em; height: 3em;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import licensingInvoicesClient from '@/api/licensingInvoices.js'
import subscriptionInvoicesClient from '@/api/subscriptionInvoices.js'

export default {
  name: 'InvoiceList',

  data () {
    return {
      downloadUrlCache: {},
      subscriptionInvoices: [],
      subscriptionLoaded: false,
      licensingInvoices: [],
      licensingLoaded: false
    }
  },

  created () {
    subscriptionInvoicesClient.listAll().then(invoices => {
      this.subscriptionInvoices = invoices
      this.subscriptionLoaded = true
    })
    licensingInvoicesClient.listAll().then(invoices => {
      this.licensingInvoices = invoices
      this.licensingLoaded = true
    })
  },

  methods: {
    handleSubscriptionPdfDownload (pk) {
      subscriptionInvoicesClient.pdf(pk).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `invoice-${pk}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
    },

    handleLicensingPdfDownload (pk) {
      licensingInvoicesClient.pdf(pk).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `invoice-${pk}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
    }
  },

  metaInfo: {
    title: 'Invoices'
  }
}
</script>

<style>
</style>
